<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Açık Rıza Formları">
          <b-form @submit.prevent="onFilterChange">
            <b-row class="mb-2">
              <b-col cols="12" md="4">
                <b-form-group label="Arama (Ad, Soyad, E-Posta)" label-for="search-input">
                  <b-form-input
                    id="search-input"
                    v-model="search"
                    placeholder="Ara..."
                    type="text"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3">
                <b-form-group label="Başlangıç Tarihi" label-for="start-date">
                  <b-form-datepicker
                    id="start-date"
                    v-model="startDate"
                    v-bind="translation || {}"
                    :locale="locale"
                    :start-weekday="0"
                    :hide-header="false"
                    class="mb-1"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="3">
                <b-form-group label="Bitiş Tarihi" label-for="end-date">
                  <b-form-datepicker
                    id="end-date"
                    v-model="endDate"
                    v-bind="translation || {}"
                    :locale="locale"
                    :start-weekday="0"
                    :hide-header="false"
                    class="mb-1"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" md="2" class="d-flex align-items-end mb-1">
                <b-button
                  variant="outline-primary"
                  block
                  @click="onFilterChange"
                >
                  Ara
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <table class="table b-table table-responsive">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Ad Soyad</th>
                      <th>E-Posta</th>
                      <th>Telefon</th>
                      <th>Oluşturma Tarihi</th>
                      <th>Onay Tarihi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="form in forms"
                      :key="form.id"
                      :class="form.emailConfirmation ? 'table-success' : 'table-danger'"
                    >
                      <td>{{ form.id }}</td>
                      <td>{{ form.name }} {{ form.surname }}</td>
                      <td>{{ form.email }}</td>
                      <td>{{ form.phone }}</td>
                      <td>{{ form.createdAt }}</td>
                      <td>{{ form.emailConfirmationAt }}</td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="mb-2 mt-2">
                <div class="d-flex justify-content-center align-items-center">
                  <b-pagination :value="1" :total-rows="rows" :per-page="12" first-number last-number align="right"
                    prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                    @input="(value) => getFormExplicitConsents(value)">
                    <template #prev-text>
                      <feather-icon icon="ChevronLeftIcon" size="18" />
                    </template>
                    <template #next-text>
                      <feather-icon icon="ChevronRightIcon" size="18" />
                    </template>
                  </b-pagination>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  <b-button class="float-right mt-2 mr-1" v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="outline-success" target="_blank"
                    :href="`${baseUrl}/api/v1/export/forms/explicit-consents?search=${search}&startDate=${startDate}&endDate=${endDate}`">
                    Dışa Aktar
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BCardText,
  BFormGroup,
  BFormInput,
  BFormDatepicker,
  BPagination,
  BButtonGroup,
  BListGroupItem,
  BButtonToolbar,
} from "bootstrap-vue";

import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();
export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    BPagination,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      forms: [],
      rows: 100,
      currentPage: 1,
      search: '',
      analysisResults: [],
      baseUrl: settings.apiBaseUrl,
      startDate: '',
      endDate: '',
      locale: "tr-TR",
      translation: {
        labelPrevDecade: "Önceki on yıl",
        labelPrevYear: "Geçen yıl",
        labelPrevMonth: "Geçen ay",
        labelCurrentMonth: "İçinde bulunduğumuz ay",
        labelNextMonth: "Gelecek ay",
        labelNextYear: "Gelecek yıl",
        labelNextDecade: "Gelecek on yıl",
        labelToday: "Bugün",
        labelSelected: "Seçilen Tarih",
        labelNoDateSelected: "Tarih seçilmedi",
        labelCalendar: "Takvim",
        labelNav: "Takvimde gezinme",
        labelHelp: "Takvimde gezinmek için ok tuşlarını kullanın",
      },
    };
  },
  watch: {
    currentPage: {
      handler: function (newVal) {
        this.getFormExplicitConsents(newVal);
      },
      deep: true,
    },
  },
  methods: {
    getFormExplicitConsents(page) {
      endpoints
        .getFormExplicitConsents(page, this.search, this.startDate, this.endDate, this.$i18n.locale, () => { })
        .then((data) => {
          this.forms = [...data.response.data];
          this.rows = data.response.meta.total;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onFilterChange() {
      this.getFormExplicitConsents(1);
    },
  },
  mounted() {
    this.getFormExplicitConsents(1);
  },
};
</script>
<style scoped>
.table th,
.table td {
  white-space: nowrap;
}
</style>
